import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const OccurrenceAssociatedVehiclesService = {
    apply: async (payload) => axios.post(API_URL + "/occurrence_associated_vehicles/apply", payload).then(({ data }) => data).catch((err) => { throw err }),
}

export default OccurrenceAssociatedVehiclesService;